module.exports = __webpack_public_path__ + "img/result-failure.ac714a30.svg";